export const shouldQueryWorkspaceActivity = (
  workspaceId: null | string,
): boolean => workspaceId !== null && workspaceId.length > 0;
